import { render } from "./DashboardRecentMessages.vue?vue&type=template&id=a18c1fd8"
import script from "./DashboardRecentMessages.vue?vue&type=script&lang=js"
export * from "./DashboardRecentMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__